var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-grade-post-list" },
    [
      _c("p", { staticClass: "text large bold dark" }, [
        _vm._v("Order Transcript 寄送成绩单")
      ]),
      _vm._m(0),
      _c("p", { staticClass: "big bold dark mt-30" }, [_vm._v("我的订单")]),
      _c(
        "ElTable",
        { staticClass: "mt-10 table-wrap", attrs: { data: _vm.orderData } },
        [
          _c("ElTableColumn", {
            attrs: { prop: "time", label: "日期", width: "180" }
          }),
          _c("ElTableColumn", { attrs: { prop: "feeStr", label: "金额" } }),
          _c("ElTableColumn", {
            attrs: { prop: "paidState", label: "支付状态" }
          }),
          _c("ElTableColumn", {
            attrs: { prop: "expressState", label: "寄送状态" }
          }),
          _c("ElTableColumn", {
            attrs: { width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isPaid
                      ? _c(
                          "Button",
                          {
                            staticClass: "btn-detail",
                            attrs: { size: "small", skin: "grey" },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("查看详情")]
                        )
                      : _c(
                          "Button",
                          {
                            staticClass: "btn-detail",
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("支付订单")]
                        )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "a",
        {
          staticClass: "mt-10 reload link text red bold",
          on: { click: _vm.resetOrderData }
        },
        [_vm._v("刷新")]
      ),
      _c(
        "Button",
        {
          staticClass: "btn-submit mt-30",
          on: {
            click: function($event) {
              return _vm.handleClick()
            }
          }
        },
        [_vm._v("新建订单")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text mt-20" }, [
      _vm._v(
        " 我们很高兴可以为峰会校友提供成绩单的寄送服务。所有成绩单的寄送都需经由在线系统提出申请，并按要求填写一系列的信息。提交申请后，成绩单会进行专门的封存并邮寄到你指定的地点。"
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        " 正式成绩单将会在订购后的10个工作日内（不含周末、公共假期等节假日）寄出。成绩单寄送均使用顺丰快递，从2023年9月1日起寄送中国地区(含港澳台) 的价格为每份成绩单（包含运费）60元，寄送海外地址价格为第一张证书400元（若同一地址需多份，每份另加60元）。一般来说，国内的地址会在寄出后一周内送达，国外的地址会在15-20天左右送达。由于无法直接控制快递公司的寄送速度，有时也会出现预计时间长的情况，敬请体谅。"
      ),
      _c("br"),
      _c("br"),
      _vm._v(" 对于你的成绩单寄送有任何问题，可以通过"),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: { href: "mailto:apply@hsylc.cn", target: "_blank" }
        },
        [_vm._v("apply@hsylc.cn")]
      ),
      _vm._v("联系我们。 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }